






































































import Vue from 'vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { generateAndDownloadCSV } from '@/web/utils/csv-export';
import { formatDate } from '@/web/utils/format';

interface LocalState {
  couponUsage: CouponUsageResponse[];
}

export default Vue.extend({
  name: 'CouponDetail',
  data(): LocalState {
    return {
      couponUsage: [],
    };
  },
  components: {
    NavItem,
  },
  computed: {
    ...mapGetters({
      teacherCoupon: 'product/teacherCoupon',
      paymentInfo: 'setting/paymentInfo',
    }),
    discountAmount(): string {
      const teacherCoupon = this.teacherCoupon as TeacherCouponsResponse;
      if (teacherCoupon.discount_type === 'percentage') {
        return `-${teacherCoupon.discount_amount}%`;
      }
      return `-${this.$formatCurrency(
        teacherCoupon.discount_amount || 0,
        this.paymentInfo.currency
      )}`;
    },
    expired(): boolean {
      const teacherCoupon = this.teacherCoupon as TeacherCouponsResponse;
      return moment(teacherCoupon.redeem_end).isBefore(new Date());
    },
  },
  mounted() {
    this.$store.dispatch('setting/getPaymentInfo');
    const id = parseInt(this.$route.params['id']);
    Promise.all([
      this.$store.dispatch('product/getTeacherCouponDetail', id),
      this.$store.dispatch('product/getCouponsUsage', id),
    ]).then(res => {
      this.couponUsage = res[1];
    });
  },
  methods: {
    navigateToAllCoupons(): void {
      this.$router.push('/products/coupons/');
    },
    navigateToEdit(): void {
      const id = parseInt(this.$route.params['id']);
      this.$router.push(`/products/coupons/${id}/edit/`);
    },
    formatDate(date: string): string {
      return formatDate(date, 'date-time');
    },
    exportCsv(): void {
      generateAndDownloadCSV(this.teacherCoupon.name, this.couponUsage);
    },
  },
});
